import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';
import styled from 'styled-components';

import {
  CardSwapBanner as CardSwapBannerDumb,
  Props as CardSwapBannerDumpProps,
} from '@sorare/core/src/components/cardswap/Banner';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import { useEvents } from '@sorare/us-sports/src/hooks/useEvents';

import { useCurrentUserContext as useCurrentUserNBAContext } from 'contexts/currentNBAUser';

import { CardSwapDialog } from '../Dialog';
import {
  NextNbaCardTradeQuery,
  NextNbaCardTradeQueryVariables,
} from './__generated__/index.graphql';
import background from './assets/banner_background_lines.svg';

const NBABanner = styled(CardSwapBannerDumb)`
  height: 100%;
  background-color: #2b2d32;
  background-position: right;
  background-image: url(${background}),
    linear-gradient(300deg, rgba(52 84 209 / 90%) 5%, rgba(52 84 209 / 0%) 85%);
  background-size: cover;
`;

const NEXT_NBA_CARD_TRADE = gql`
  query NextNbaCardTradeQuery {
    currentUser {
      slug
      nextNBACardTradeAvailableAfter
      latestNBACardTrade {
        id
        expiresAfter
        isComplete
      }
    }
  }
` as TypedDocumentNode<NextNbaCardTradeQuery, NextNbaCardTradeQueryVariables>;

type Props = {
  Banner?: (props: CardSwapBannerDumpProps) => React.JSX.Element | null;
};

export const CardSwapBanner = ({ Banner = NBABanner }: Props) => {
  const track = useEvents();
  const { currentUser } = useCurrentUserContext();
  const { needsOnboarding } = useCurrentUserNBAContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  const { data, refetch } = useQuery(NEXT_NBA_CARD_TRADE, {
    skip: !currentUser || needsOnboarding,
    errorPolicy: 'ignore',
  });

  const nextTradeAvailable = data?.currentUser?.nextNBACardTradeAvailableAfter;
  const trade = data?.currentUser?.latestNBACardTrade;
  const tradeInProgress = Boolean(trade && !trade.isComplete);

  if (!nextTradeAvailable) {
    return null;
  }

  return (
    <>
      <CardSwapDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          refetch();
        }}
      />
      <Banner
        tradeInProgress={tradeInProgress}
        nextTradeAvailable={nextTradeAvailable}
        onClick={() => {
          track('Click Swap');
          setDialogOpen(true);
        }}
      />
    </>
  );
};
